@if (value !== null && value !== undefined) {
    <span [style.width.px]="width">
        <a href="javascript:void(0);" (click)="onClick()" style="color:#999999; text-decoration: underline;">{{value}}</a>
    </span>
}
@if (busy) {
    <img src="{{localImageLocation}}ajax-loader.gif" class="link-busy" alt="loading">
}
